import {
  aStartSumoRecordSearchJob,
  mockStartSumoRecordSearchJobOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockStartSumoRecordSearchJobOperationMutation(
    async ({ query: _query, variables }) => {
      await delay(1500);
      const { q } = variables;
      const overrides =
        q === `objectType:\"NetworkProxy"` ? { jobId: '1' } : {};

      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          startSumoRecordSearchJob: aStartSumoRecordSearchJob(overrides),
        },
      });
    }
  ),
];
